import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserSpacePetsGameProps {
    onComplete: () => void;
}

interface PhaserSpacePetsGameState {
}

const gameConfig: GameConfig = {
    title: "Space Pets Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserSpacePetsGame extends React.Component<PhaserSpacePetsGameProps, PhaserSpacePetsGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserSpacePetsGameProps) {
        super(props);
        bindAllOfThis(this, PhaserSpacePetsGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserSpacePetsGame;



// WEBPACK FOOTER //
// ./src/games/SpacePets/Main.tsx